export enum UserRole {
  Admin = "ADMIN",
  Distributor = "DISTRIBUTOR",
  Support = "SUPPORT",
  User = "USER",
}

export interface MeAccessDto {
  apiKey: string | null;
  expiryDate: string;
  productId: string;
}

export interface MeAccess extends MeAccessDto {}

export interface MeDto {
  access: MeAccessDto[];
  email: string;
  organization: string;
  role: UserRole;
}

export interface Me extends MeDto {
  access: MeAccess[];
}
